export const REDUX_NAMESPACE = 'KEYFRAME_MANIPULATION';
export const MIN_BLUR = 0;
export const MAX_BLUR = 300;
